import { render, staticRenderFns } from "./batch-import.vue?vue&type=template&id=dba64610&scoped=true"
import script from "./batch-import.vue?vue&type=script&lang=js"
export * from "./batch-import.vue?vue&type=script&lang=js"
import style0 from "./batch-import.vue?vue&type=style&index=0&id=dba64610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-load_84097bf1da1fe89cf094ff7a2cbe4d08/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba64610",
  null
  
)

export default component.exports